<script setup lang="ts">
interface Props {
    serialnumber: string;
}

const { serialnumber } = defineProps<Props>();
</script>

<template>
    <patternlib-empty-state>
        <patternlib-empty-state-visual slot="visual" size="big" icon-name="eco" />
        <p slot="description">{{ $t('general.dataNotFound', {sku: serialnumber}) }}</p>
    </patternlib-empty-state>
    <!-- <p>{{ $t('general.dataNotFound') }}</p> -->
</template>

<style lang="css" scoped>
</style>